import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Eye, X, ArrowLeftRight } from 'lucide-react';
import { getImpersonation, stopImpersonating } from '@/lib/axiosClient';

/**
 * Shown across all dashboards while a super_admin is impersonating, OR a
 * farm_manager has selected an active farm to operate on.
 *
 * Props:
 *   role (string): the logged-in user's role (super_admin | farm_manager | ...)
 *                  Used to choose label + exit destination.
 */
const ImpersonationBanner = ({ role }) => {
  const navigate = useNavigate();
  const imp = getImpersonation();
  if (!imp) return null;

  const isFarmManager = role === 'farm_manager';

  const exit = () => {
    stopImpersonating();
    navigate(isFarmManager ? '/farm-manager' : '/admin');
    setTimeout(() => window.location.reload(), 50);
  };

  return (
    <div
      className={`${isFarmManager ? 'bg-blue-600' : 'bg-purple-600'} text-white px-4 py-2 flex items-center justify-between text-sm`}
    >
      <div className="flex items-center gap-2">
        <Eye className="w-4 h-4" />
        <span>
          {isFarmManager ? (
            <>
              <strong>Farm Manager:</strong> working on <strong>{imp.farmName || imp.farmId}</strong>
            </>
          ) : (
            <>
              <strong>Super Admin:</strong> viewing <strong>{imp.farmName || imp.farmId}</strong> as Owner
            </>
          )}
        </span>
      </div>
      <button
        onClick={exit}
        data-testid="exit-impersonation"
        className="inline-flex items-center gap-1 bg-white/20 hover:bg-white/30 px-3 py-1 rounded-md"
      >
        {isFarmManager ? <ArrowLeftRight className="w-3.5 h-3.5" /> : <X className="w-3.5 h-3.5" />}
        {isFarmManager ? 'Switch farm' : 'Exit'}
      </button>
    </div>
  );
};

export default ImpersonationBanner;
